const translations = {
    en: {
        shared: {
            weather: {
                default: 'Variable',
                'clear-day': 'Clear day', 
                'clear-night': 'Clear night', 
                'rain': 'Rain', 
                'snow': 'Snow', 
                'sleet': 'Sleet', 
                'wind': 'Wind', 
                'fog': 'Fog', 
                'cloudy': 'Cloudy', 
                'partly-cloudy-day': 'Partially cloudy day', 
                'partly-cloudy-night': 'Partially cloudy night'
            }
        }
    },
    de: {
        shared: {
            weather: {
                default: 'veränderlich',
                'clear-day': 'klar', 
                'clear-night': 'klar', 
                'rain': 'Regel', 
                'snow': 'Schnee', 
                'sleet': 'Schneeregen', 
                'wind': 'Wind', 
                'fog': 'Nebel', 
                'cloudy': 'wolkig', 
                'partly-cloudy-day': 'wechselnd wolkig', 
                'partly-cloudy-night': 'wechselnd wolkig'
            }
        }
    },
    es: {
        shared: {
            weather: {
                default: 'Variable',
                'clear-day': 'Dia Despejado', 
                'clear-night': 'Noche Despejada', 
                'rain': 'Lluvia', 
                'snow': 'Nieve', 
                'sleet': 'Aguanieve', 
                'wind': 'Viento', 
                'fog': 'Niebla', 
                'cloudy': 'Nublado', 
                'partly-cloudy-day': 'Dia parcialmente nublado ', 
                'partly-cloudy-night': 'Noche parcialmente nublada'
            }
        }
    },
    fr: {
        shared: {
            weather: {
                default: 'Variable',
                'clear-day': 'Clair', 
                'clear-night': 'Clair', 
                'rain': 'Pluie', 
                'snow': 'Neige', 
                'sleet': 'Neige fondue', 
                'wind': 'Vent', 
                'fog': 'Brouillard', 
                'cloudy': 'Nuageux', 
                'partly-cloudy-day': 'Jour partiellement nuageux', 
                'partly-cloudy-night': 'Nuit partiellement nuageuse'
            }
        }
    },
    it: {
        shared: {
            weather: {
                default: 'Variabile',
                'clear-day': 'Giornata limpida', 
                'clear-night': 'Notte limpida', 
                'rain': 'Pioggia', 
                'snow': 'Neve', 
                'sleet': 'Nevischio', 
                'wind': 'Vento', 
                'fog': 'Nebbia', 
                'cloudy': 'Nuvoloso', 
                'partly-cloudy-day': 'Giornata parzialmente nuvolosa', 
                'partly-cloudy-night': 'Notte parzialmente nuvolosa'
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/shared/Weather.js